<app-banner-app [retroSelected]="false"></app-banner-app>

<br>
<div class="container">
    <br><br><br><br>
    <div class="row contenido">
        <div class="col">
            <div class="textoArriba">
                <br><br>
                <div>
                    <h3 class="texto2">Tu pago ha sido rechazado</h3>
                    <h5 class="texto1">
                        Tu pago por $ {{ 'this.precioPlanSeleccionado' }} no se ha completado.<br>
                        Por favor, verifica tus datos de
                        pago e inténtalo nuevamente.
                    </h5>
                </div>
                <br><br>
                <img src="./assets/img/Rotura_de_maquinaria.png"/>
            </div>
            <div class="textoAbajo">
                <img src="./assets/img/Rotura_de_maquinaria.png"/>
                <br><br><br>
                <div>
                    <h3 class="texto2">Tu pago ha sido rechazado</h3>
                    <h5 class="texto1">
                        Tu pago por $ {{ 'this.precioPlanSeleccionado' }} no se ha completado.<br>
                        Por favor, verifica tus datos de
                        pago e inténtalo nuevamente.
                    </h5>
                </div>
            </div>
            <br><br>

            <div class="container tamanioBoton">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="intentarDeNuevo()">
                    Intentar de nuevo
                </button>
            </div>
        </div>
    </div>

    <br><br><br><br>
</div>

<div class="textoArriba">
    <app-footer-app />
</div>
